import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'BookingTag',
  props: {
    tag: null
  },
  setup(__props: any) {

const props = __props as {
  tag: string;
};



const cssClass = computed(() => {
  let tag = props.tag;
  if (tag) {
    tag = tag.toLowerCase();
  }

  return `booking-tag--${tag}`
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["booking-tag", _unref(cssClass)])
  }, _toDisplayString(__props.tag), 3))
}
}

})